import shopifyGenericDefaults from '../shopify-generic/config.js';

export default {
  ...shopifyGenericDefaults,
  includes: ['shopify-generic'],
};
